import { useTranslation } from "react-i18next";
import { FooterLink, type FooterLinkItem } from "./FooterLink";

export interface FooterBottomBarProps {
  year: number;
  legalLinks: readonly FooterLinkItem[];
}

/**
 * La línea inferior del pie: copyright a la izquierda, enlaces legales a
 * la derecha; apilados en móvil.
 *
 * El año se recibe por props en vez de calcularse aquí con `new Date()`:
 * un componente que lee el reloj no se puede probar sin congelar el tiempo.
 */
export function FooterBottomBar({ year, legalLinks }: FooterBottomBarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-[12px] text-ds-ink-3">
        © {year} It&apos;s The Best · {t("Todos los derechos reservados")}
      </p>

      <ul className="flex flex-wrap items-center gap-x-5 gap-y-2">
        {legalLinks.map((link) => (
          <li key={link.to}>
            <FooterLink {...link} />
          </li>
        ))}
      </ul>
    </div>
  );
}
